<template>
  <div>
    <colour-picker v-model="colour"></colour-picker>
    <div class="pick-width">
      <div class="field is-grouped">
        <label class="label">{{ $t("width") }}</label>
        <p v-for="width in widthOptions" :key="width" class="control">
          <a class="button is-outlined" :class="{'is-info': width === borderWidth}" @click="borderWidth = width">
            <span :class="'width' + width">{{width}}</span>
          </a>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import ColourPicker from './ColourPicker'
import i18n from '@/i18n'

export default {
  props: ['settings', 'line'],
  components: {
    ColourPicker
  },
  data: function () {
    return {
      colour: null,
      widthOptions: [0, 1, 3, 5, 10],
      borderWidth: 0
    }
  },
  mounted: function () {
    this.colour = this.settings.colour
    this.borderWidth = this.settings.width
  },
  methods: {
    title: function () {
      return this.line ? i18n.t('magicboard.colour') : 'Border Settings'
    },
    update: function () {
      this.settings.colour = this.colour
      this.settings.width = this.borderWidth
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '~styles/utils.scss';

  .modal-card-body {
    padding: 2%;
  }

  .pick-width {
    margin: 2% auto;

    label {
      line-height: 2.25rem;
      margin: 0 0.75rem 0 0;

      @include mobile {
        font-size: 0.75rem;
        margin: 0 0.6rem 0 0.3rem;
      }
    }

    .button {
      padding: 0.5rem 1.5rem;

      span {
        border-bottom: solid black;
        padding: 0 0.5rem;

        &.width0 { border: none; }
        &.width1 { border-width: 1px; }
        &.width3 { border-width: 3px; }
        &.width5 { border-width: 5px; }
        &.width10 { border-width: 7px; }
      }

      @include mobile {
        padding: 0 0.5rem;
      }
    }
  }
</style>
